// src/i18n/en/common.js
const common = {
    actions: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        refresh: 'Refresh',
    },
    status: {
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        completed: 'Completed',
        cancelled: 'Cancelled',
    },
    messages: {
        loading: 'Loading...',
        saving: 'Saving...',
        error: 'An error occurred',
        success: 'Operation successful',
        confirm_delete: 'Are you sure you want to delete?',
        no_data: 'No data available',
    },
    notifications: {
        // Session messages
        session_extended_success: 'Session extended successfully',
        session_extended_with_time: 'Session extended successfully. New expiration: %{time}',
        session_expired: 'Your session has expired. Please log in again.',
        session_will_expire: 'Your session will expire soon. Please save your work and log in again.',
        session_extend_error: 'Error extending session. Please save your work.',
        connection_error: 'Connection error. Please check your internet connection.',
        
        // General errors and success
        load_error: 'Error loading data',
        save_success: 'Data saved successfully',
        save_error: 'Error saving data',
        update_success: 'Data updated successfully',
        update_error: 'Error updating data',
        delete_success: 'Item deleted successfully',
        delete_error: 'Error deleting item',
        
        // Validation messages
        field_required: 'This field is required',
        invalid_format: 'Invalid format',
        duplicate_key: 'This key already exists',
        permission_denied: 'You do not have permission to perform this action',
        
        // File operations
        file_select_required: 'Please select a file',
        file_size_exceeded: 'File size should not exceed 2MB',
        
        // Connection and testing
        connection_success: 'Connection successful',
        connection_failed: 'Connection failed',
        test_connection_error: 'Error testing connection',
        
        // Copy operations
        copied_to_clipboard: 'Copied to clipboard',
    },
    warnings: {
        delete_irreversible: 'This action cannot be undone',
    },
    hotel: 'Hotel',
    not_assigned: 'Not assigned',
};

export default common;